import { jsx as _jsx } from "react/jsx-runtime";
import { createPageComponent } from "../utils/createPageComponent";
import { BaseErrorPage } from "../components/BaseErrorPage";
import { NotFoundErrorPageButtons } from "./Error404Buttons";
const Page = () => (_jsx(BaseErrorPage, { titleTransKey: "notFoundError.title", infoTransKey: "notFoundError.info", buttons: _jsx(NotFoundErrorPageButtons, {}) }));
export const NotFoundErrorPage = createPageComponent(Page);
